import { gql } from "@apollo/client";

const VideoFragments = {
  entry: gql`
    fragment Video on Race {
      video {
        liveStreaming
        onTvg
        onTvg2
        streams
        hasReplay
        replayFileName
        mobileAvailable
        isStreamHighDefinition
      }
    }
  `
};

export default VideoFragments;
